import { get, isArray } from 'lodash-es';

export function joinFilter() {
  return ( values: any[], sepator: string = ', ', field: string ): string => {
    if ( !isArray(values) ) {
      return '';
    }
    if ( field ) {
      return values.map(( item ) => get(item, field)).join(sepator);
    }
    return values.join(sepator);
  };
}



// WEBPACK FOOTER //
// ./app/shared/filters/join.filter.ts